import { Component } from '@angular/core';

@Component({
  selector: 'app-cooperate-page',
  templateUrl: './cooperate-page.component.html',
  styleUrls: ['./cooperate-page.component.scss'],
})
export class CooperatePageComponent {
  thridPartList: any = [
    {
      img: '../../../assets/images/cooperate/third-part-1.webp',
      color: '#FE5B0B',
      title: '产品类别',
      text: '海外流媒体账号、AI账号、办公账号、礼品卡、国际代付等',
    },
    {
      img: '../../../assets/images/cooperate/third-part-2.webp',
      color: '#2F64FF',
      title: '售后要求',
      text: '由于产品特殊性，需要保证及时的售后与产品问题解决方案',
    },
    {
      img: '../../../assets/images/cooperate/third-part-3.webp',
      color: '#8165F7',
      title: '供应能力',
      text: '一手货源，产能稳定',
    },
    {
      img: '../../../assets/images/cooperate/third-part-4.webp',
      color: '#44B01A',
      title: '价格优势',
      text: '具备市场竞争力的报价体系与持续优化能力',
    },
  ];

  forthPartList: any = [
    {
      id: 1,
      text: '长期稳定的采购订单',
    },
    {
      id: 2,
      text: '定期供应商评估与战略合作升级机会',
    },
    {
      id: 3,
      text: '高效透明的合作流程',
    },
  ];

  fifthPartList: any = [
    {
      img: '../../../assets/images/cooperate/fifith-part-1.webp',
      text: '产品目录与报价单',
    },
    {
      img: '../../../assets/images/cooperate/fifith-part-2.webp',
      text: '产能及交货周期说明',
    },
    {
      img: '../../../assets/images/cooperate/fifith-part-3.webp',
      text: '合作案例（可选）',
    },
  ];
}
